import { ReactNode, useState } from 'react';
import DocumentPreview from './DocumentPreview';
import { MetadataState } from './DetectedMetadata';
import ReviewInspector from './ReviewInspector';
import { DocumentDetail } from './detailModel';
export default function DocumentReading({doc,privileged,showData,metadata,fileContent}:{fileContent?:ReactNode;doc:DocumentDetail;privileged:boolean;showData:boolean;metadata:MetadataState}) {
 const [pageRequest,setPageRequest]=useState<{page:number;requestId:number}>();
 return <>
  <div className={`review-reading ${showData && privileged ? 'with-evidence' : ''}`}>
   <div className="min-w-0" id={`reading-${doc.id}`}><DocumentPreview doc={doc} pageRequest={pageRequest}/></div>
   {showData && privileged && <ReviewInspector state={metadata} fileContent={fileContent} onPage={page=>{setPageRequest({page,requestId:Date.now()});document.getElementById(`reading-${doc.id}`)?.scrollIntoView({block:'start',behavior:'auto'});}}/>}
  </div>
 </>;
}
